import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button, Icon, Input, Div, H1 } from '@driftt/tide-core'
import './style.css'


class PasswordLoginStep extends Component {

  static propTypes = {
    password: PropTypes.string,
    setPassword: PropTypes.func.isRequired,
    goBackToEmailStep: PropTypes.func.isRequired,
    submitLogin: PropTypes.func.isRequired,
    forgotPasswordState: PropTypes.string.isRequired,
    errorMessage: PropTypes.string
  }

  setPassword = ({ target }) => {
    this.props.setPassword(target.value)
  }

  submitLogin = (event) => {
    event.preventDefault()
    this.props.submitLogin()
  }

  render() {
    const {
      password,
      forgotPasswordState,
      errorMessage,
      goBackToEmailStep,
    } = this.props

    return (
      <Div>
        <H1>Enter your password</H1>
        <form className="drift-form" onSubmit={this.submitLogin}>
          <Input
            size="large"
            value={password}
            onChange={this.setPassword}
            className="large email-form"
            id="password"
            name="password"
            type="password"
            placeholder="Your password"
            required
            autoComplete="on"
          />
          {errorMessage &&
            <strong className="request-status error">
              {errorMessage}
            </strong>
          }
          <Button size="large" onClick={this.submitLogin} disabled={!password}>
            Sign in
          </Button>
        </form>

        <Link
          className="solo-link"
          to={{
            pathname: '/forgot-password',
            state: { forgotPasswordState }
          }}>
          I forgot my password
        </Link>
        <Button
          className="solo-link"
          type="utility"
          icon="arrow-1-left"
          onClick={goBackToEmailStep}
        >
            Back
        </Button>
      </Div>
    )
  }
}

export default PasswordLoginStep



// WEBPACK FOOTER //
// ./src/components/pages/Login/PasswordLoginStep/index.js